import creator from "./creator";
import form from "./form";
import get from "./get";
import record from "./record";
import locations from "./locations";
import assignedLocations from "./assignedLocations";
import assignLocations from "./assignLocations";

export default {
  namespaced: true,
  modules: {
    creator,
    form,
    get,
    record,
    locations,
    assignedLocations,
    assignLocations,
  },
};
